export default __webpack_public_path__ + "static/media/chavi.634fc537.jpg";